import { render, staticRenderFns } from "./AdddeptRight.vue?vue&type=template&id=750751a4&scoped=true"
import script from "./AdddeptRight.vue?vue&type=script&lang=js"
export * from "./AdddeptRight.vue?vue&type=script&lang=js"
import style0 from "./AdddeptRight.vue?vue&type=style&index=0&id=750751a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750751a4",
  null
  
)

export default component.exports